// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

export const ComponentTextFragmentDoc = `
    fragment componentText on ComponentText {
  __typename
  alignment
  text
  textSize
}
    `;